import React, { useEffect } from 'react';
import './../styles/service-page.css';

const RoofCleaningPage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);

    // Parallax effect for hero background
    // const handleScroll = () => {
    //   const scrolled = window.scrollY;
    //   const heroBackground = document.querySelector('.hero-section');
    //   if (heroBackground && scrolled < 600) {
    //     const yPos = -(scrolled * 0.5);
    //     heroBackground.style.backgroundPositionY = `${yPos}px`;
    //   }
    // };

    // window.addEventListener('scroll', handleScroll);

    // Add scroll animations matching homepage
    const observeElements = () => {
      const elements = document.querySelectorAll('.slide-in-up, .slide-in-left, .slide-in-right');
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      elements.forEach(element => {
        observer.observe(element);
      });

      // Stagger animations for service cards
      const cards = document.querySelectorAll('.service-card');
      cards.forEach((card, index) => {
        card.style.transitionDelay = `${index * 0.1}s`;
      });

      // Stagger process steps
      const steps = document.querySelectorAll('.process-step');
      steps.forEach((step, index) => {
        step.style.transitionDelay = `${index * 0.15}s`;
      });
    };

    setTimeout(observeElements, 100);

    // Cleanup
    // return () => {
    //   window.removeEventListener('scroll', handleScroll);
    // };
  }, []);

  return (
    <div className="service-page">
      {/* Hero Section with Background Image */}
      <section 
        className="hero-section"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),url('https://media.istockphoto.com/id/1363120254/photo/washed-and-non-washed-roof-tiles-tiles-covered-with-lichen-mould-and-moss-and-cleaned-tiles.jpg?s=612x612&w=0&k=20&c=wsyEZNU9sAQijMUMBZU5obN46zBsltee8Wezi8PaMvo=')`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="header-content slide-in-up">
            <h1>Roof Cleaning</h1>
            <p className="header-subtitle">
              Expert roof cleaning services using soft-wash techniques. Remove algae, moss, and stains safely without damaging your roofing materials.
            </p>
          </div>
        </div>
      </section>

      {/* Service Overview */}
<section className="service-overview">
  <div className="container">
    <div className="overview-grid">
      <div className="overview-content slide-in-left">
        <h2>Why Choose Our Roof Cleaning Service?</h2>
        <p>
          A clean roof isn't just about aesthetics – it's about protecting your biggest 
          investment. Moss, algae, and lichen growth can lift tiles, trap moisture, and 
          significantly reduce your roof's lifespan. These organic growths not only make 
          your property look neglected but can lead to expensive repairs if left untreated.
        </p>
        <p>
          Our professional roof cleaning service uses low-pressure soft washing techniques 
          that safely remove moss, algae, and dirt without damaging your tiles or warranty. 
          We treat all roof types including clay tiles, concrete tiles, slate, and composite 
          materials, using biocidal treatments that prevent regrowth for years to come.
        </p>
        <div className="key-benefits">
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Extends roof lifespan by up to 10 years</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Soft wash – no high pressure damage</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Long-lasting biocidal treatment</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Fully insured for working at height</span>
          </div>
        </div>
      </div>
      <div className="overview-image slide-in-right">
        <img src="https://media.istockphoto.com/id/486093714/photo/roof-cleaning-with-high-pressure.jpg?s=612x612&w=0&k=20&c=dMokImgSi_iSIVvcoeG1f-jRdFKQSIfqtKIXg2N4yy4=" alt="Professional roof cleaning service removing moss" />
      </div>
    </div>
  </div>
</section>

      {/* What's Included */}
      <section className="whats-included">
        <div className="container">
          <h2 className="section-title slide-in-up">What's Included in Our Roof Cleaning Service</h2>
          
          <div className="services-grid">
            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🏠</span>
              </div>
              <h3>Soft-Wash Technology</h3>
              <p>
                Gentle, low-pressure cleaning that effectively removes stains and growth without damaging delicate roofing materials.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🦠</span>
              </div>
              <h3>Algae & Moss Elimination</h3>
              <p>
                Complete removal of harmful algae, moss, and lichen that can compromise your roof\'s integrity and appearance.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🛡️</span>
              </div>
              <h3>Material-Specific Treatment</h3>
              <p>
                Customized cleaning approaches for asphalt shingles, tile, metal, and other roofing materials to ensure safe, effective cleaning.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🌱</span>
              </div>
              <h3>Eco-Safe Solutions</h3>
              <p>
                Biodegradable cleaning solutions that are safe for your family, pets, and landscaping while being tough on roof contaminants.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>♻️</span>
              </div>
              <h3>Eco-Safe Products</h3>
              <p>
                All our cleaning products are environmentally friendly and safe for your family, 
                pets, and surrounding landscaping while still being tough on dirt and stains.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>✅</span>
              </div>
              <h3>Quality Guarantee</h3>
              <p>
                We stand behind our work with a complete satisfaction guarantee. If you're not 
                happy with the results, we'll return to address any concerns at no extra cost.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Process */}
      <section className="our-process">
        <div className="container">
          <h2 className="section-title slide-in-up">Our Simple 4-Step Process</h2>
          
          <div className="process-steps">
            <div className="process-step slide-in-left">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Free Quote & Assessment</h3>
                <p>
                  Contact us for a free, no-obligation quote. We'll assess your Roof's 
                  condition and provide you with a detailed estimate of the work required.
                </p>
              </div>
            </div>

            <div className="process-step slide-in-right">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Preparation & Setup</h3>
                <p>
                  We'll protect your property and surrounding areas, then apply pre-treatment 
                  solutions to problem areas and set up our professional cleaning equipment.
                </p>
              </div>
            </div>

            <div className="process-step slide-in-left">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Professional Cleaning</h3>
                <p>
                  Using the correct pressure settings for your Roof material, we systematically 
                  clean every area, paying special attention to stained and heavily soiled sections.
                </p>
              </div>
            </div>

            <div className="process-step slide-in-right">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Final Inspection</h3>
                <p>
                  We conduct a thorough quality check to ensure all areas have been properly cleaned, 
                  and discuss optional protective treatments to maintain your Roof's appearance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content slide-in-up">
            <h2>Ready to Restore Your Roof?</h2>
            <p>
              Get your free quote today and see how we can transform your Roof's appearance. 
              Most quotes provided within 24 hours with no obligation to proceed.
            </p>
            <div className="cta-buttons">
              <a href="/#contact" className="btn btn-primary">Get Free Quote</a>
            </div>
            <div className="cta-assurance">
              <span>✓ Fully insured</span>
              <span>✓ Satisfaction guaranteed</span>
              <span>✓ Free quotes</span>
              <span>✓ No hidden fees</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RoofCleaningPage;